import {
  IS_CONFIRM_DIALOG_OPEN,
  SET_DIALOG_DATA
} from "types/actions/confirm-dialog"

const postsIntialState = {
  isOpen: false,
  data: {
    title: "",
    content: "",
    confirmButton: {
      title: "",
      type: "",
      color: ""
    },
    cancelButton: {
      title: "",
      type: "",
      color: ""
    },
    handleConfirm: "",
    handleCancel: ""
  }
}

export default (state = postsIntialState, action) => {
  switch (action.type) {
    case IS_CONFIRM_DIALOG_OPEN:
      return {
        ...state,
        isOpen: !state.isOpen
      }
    case SET_DIALOG_DATA:
      return {
        ...state,
        data: action.data
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/confirm-dialog.js